import http from '/@/api/fetch';
import { IReGetsWebConfig, IResGetWebConfig } from './model';

const API = {
  getCompanyId: '/system/domain/get-companyId',
  getWebConfig: '/activity-web/saas/config/web/website-get',
  getWebConfigs: '/activity-web/saas/config/web/index-get',
};

/**
 * 获取域名对应的企业id
 */
export const getCompanyId = (params: { domainText: string }) =>
  http.get<string>(API.getCompanyId, params, { requireLogin: false, canCancel: true });

/**
 * 获取网站配置信息（用户协议、隐私协议等等）
 */
export const getWebConfig = (params: { companyId: string }) => {
  return http.get<IReGetsWebConfig>(API.getWebConfig, params);
};

/**
 * 获取网站相关图片
 */
export const getWebConfigs = (params: { companyId: string }) => {
  return http.get<IResGetWebConfig>(API.getWebConfigs, params);
};
